import { Empty, SelectProps, Spin } from 'antd'
import { Select } from 'components/atoms'
import { transformData, useProfile } from 'hooks'
import { t } from 'i18next'
import { IOptionItem } from 'interfaces'
import { ReactNode, useEffect, useState } from 'react'
import { useClinicServices } from 'services'

interface IProps extends SelectProps<any, any> {
  title?: string | ReactNode
  required?: boolean
  majorId?: number | undefined
  isGetAllServices?: boolean
  preventInput?: boolean
}

const SelectService = (props: IProps) => {
  const {
    title,
    required,
    majorId,
    isGetAllServices,
    value,
    defaultValue,
    onChange,
    ...resProps
  } = props
  const [fetching, setFetching] = useState(false)
  const { getClinicServices } = useClinicServices()
  const { userId } = useProfile()
  const { transformArrayObject } = transformData()
  const [options, setOptions] = useState([] as Array<IOptionItem>)

  useEffect(() => {
    if (isGetAllServices) {
      handleGetServices()
    }
  }, [isGetAllServices])

  useEffect(() => {
    if (majorId) {
      handleGetServices()
    }
  }, [majorId])

  const handleGetServices = () => {
    let services: any = []
    const query = {
      clinic_id: userId,
      major_id: majorId
    }
    getClinicServices(majorId ? { query } : undefined).then((res) => {
      setFetching(true)
      if (res._successfully) {
        services = transformArrayObject(res.data, {
          value: 'id',
          label: 'name'
        })
        setOptions(services)
        if (!services?.find((item: any) => item.value === value) && onChange) {
          // onChange(undefined, undefined)
        }
        setFetching(false)
      }
    })
  }

  return (
    <>
      <Select
        showArrow
        allowClear
        title={title || 'service'}
        placeholder="please-choose-info"
        options={options}
        required={required}
        filterOption={false}
        value={value}
        defaultValue={defaultValue}
        notFoundContent={
          fetching ? (
            <Spin size="small" />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={t('no-data')}
            />
          )
        }
        onChange={onChange}
        {...resProps}
      />
    </>
  )
}

export default SelectService
